/**
 * SnapFind Keyboard Shortcuts Module
 * Handles global keyboard shortcuts like Cmd+K or / to focus the search bar.
 *
 * @since 1.0.0
 */

export function initShortcuts() {
    // Set shortcut badge text based on OS
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const shortcutText = isMac ? '⌘K' : 'Ctrl K';
    document.querySelectorAll('.snaf-shortcut-badge').forEach((badge) => {
        badge.innerText = shortcutText;
    });

    // Global keyboard shortcut (Cmd+K or Ctrl+K or /)
    document.addEventListener('keydown', (e) => {
        if ((e.metaKey && e.key === 'k') || (e.ctrlKey && e.key === 'k') || e.key === '/') {
            // Don't intercept if user is typing in another input/textarea
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

            e.preventDefault();
            const input = document.querySelector('.snaf-searchbox .ais-SearchBox-input');
            if (input) {
                input.focus();
            }
        }
    });
}
